export default {
  login: '/login/',
  certificado_estado: '/statistics/estado-certificados/',
  company_config: '/company/config',
  company_logo_update: '/company/update/logo',
  company_banner_update: '/company/update/banner',
  company_favicon_update: '/company/update/favicon',
  category_list: '/category/list',
  category_create: '/category/create',
  category_update: (id) => `/category/detail/${id}`,
  category_update_image: (id) => `/category/update/image/${id}`,
  category_update_pdf: (id) => `/category/update/pdf/${id}`,
  category_products_list: '/category/products/list',
  company_locals_list: '/company/locals/list',
  company_fonts_list: '/font/list',
  product_create: '/product/create',
  product_update_image: (id) => `product/image/update/${id}`,
  product_detail_update: (id) => `product/detail/${id}`,
  product_form_create: (productId) => `product/${productId}/form/create`,
  product_form_update: (productId, id) =>
    `product/${productId}/form/detail/${id}`,
  product_form_list: (productId) => `product/${productId}/form/list`,
  product_form_option_create: (productoFormId) =>
    `product/form/${productoFormId}/option/create`,
  product_form_option_update_destroy: (id) =>
    `product/form/option/detail/${id}`,
  product_list: '/product/list',
  product_list_for_form_option: 'product/list/for-form-option',
  product_gallery: '/gallery/create',
  product_gallery_list: (id) => `product/${id}/gallery/list`,
  product_gallery_edit: (id) => `gallery/${id}`,
  local_list: 'local/list',
  local_area_all: (id) => `local/${id}/areas`,
  local_ubigeo_area: 'local/ubigeo-area',
  local_area_create: (id) => `local/${id}/area/create`,
  local_area_update: (localId, id) => `local/${localId}/area/${id}`,
  local_area_delete: (localId, id) => `local/${localId}/area/delete/${id}`,
  local_create: 'local/create',
  local_update: (id) => `local/update/${id}`,
  local_delete: (id) => `local/delete/${id}`,
  order_list: 'order/list',
  order_excel: 'order/download-excel/',
  order_detail: (id) => `order/detail/${id}`,
  order_detail_cancelled: (id) => `order/detail/${id}/cancelled`,
  order_detail_change_status: (id) => `v2/order/detail/${id}/change-status`,
  order_detail_chazki: (id) => `v2/order/detail/${id}/chazki`,
  order_status_chazki: (id) => `v2/order/delivery/status/${id}/`,
  order_update_shipping: (id) => `order/customer-shipping/update/${id}/`,
  banner: '/banner/',
  banner_update: (id) => `/banner/${id}`,
  banner_update_save: (id) => `/banner/${id}/`,
  banner_delete: (id) => `/banner/${id}`,
  factura_list: '/billing/list',
  factura_detail: (id) => `/billing/detail/${id}`,
  factura_files: (id) => `/billing/${id}/files`,
  factura_pdf: (id) => `/billing/${id}/pdf`,
  supplier_list: 'supplier/list',
  suppliers: 'suppliers',
  supplier_create: 'supplier/create',
  supplier_detail: (id) => `supplier/detail/${id}`,
  ubigeo_departamento_list: 'ubigeo/departamento/list',
  ubigeo_provincia_list: 'ubigeo/provincia/list',
  ubigeo_distrito_list: 'ubigeo/distrito/list',
  countries_list: 'country/list',
  coupon_spec_list: 'coupon-spec/list',
  coupon_spec_create: 'coupon-spec/create',
  coupon_spec_update: (id) => `coupon-spec/update/${id}`,
  coupon_spec_delete: (id) => `coupon-spec/delete/${id}`,
  coupon_list: (id) => `coupon-spec/${id}/coupon/list`,
  coupon_create: 'coupon/create',
  coupon_massive: (id) => `coupon-spec/${id}/coupon/massive/`,
  coupon_excel: (id) => `coupon-spec/${id}/coupon/download`,
  coupon_delete: (id) => `coupon/delete/${id}`,
  product_add_coupon: (id) => `coupon-spec/${id}/product/add/`,
  product_delete_coupon: (id, idProduct) => `coupon-spec/${id}/product/${idProduct}/remove/`,
  product_by_coupon: (id) => `coupon-spec/${id}/product/search/?page_size=5`,
  category_by_coupon: (id) => `coupon-spec/${id}/category/search/?page_size=5`,
  category_add_coupon: (id) => `coupon-spec/${id}/category/add/`,
  category_delete_coupon: (id, idCategory) => `coupon-spec/${id}/category/${idCategory}/remove/`,
  promotion_list: 'promotion/list',
  promotion_create: 'promotion/create',
  promotion_update: (id) => `promotion/update/${id}`,
  promotion_detail: (id) => `promotion/${id}`,
  product_add_promotion: (id) => `promotion/${id}/product/add/`,
  product_delete_promotion: (id, idProduct) => `promotion/${id}/product/${idProduct}/remove/`,
  product_by_promotion: (id) => `promotion/${id}/product/search/?page_size=5`,
  category_add_promotion: (id) => `promotion/${id}/category/add/`,
  category_delete_promotion: (id, idCategory) => `promotion/${id}/category/${idCategory}/remove/`,
  category_by_promotion: (id) => `promotion/${id}/category/search/?page_size=5`
}
